<script lang="ts">
	//@ts-nocheck
	import { Button } from '$lib/components/ui/button';
	import * as Card from '$lib/components/ui/card';
	import * as Carousel from '$lib/components/ui/carousel';
	import { ChevronDown, Footprints, Star, Loader2, CheckCircle } from 'lucide-svelte';
	import { Input } from '$lib/components/ui/input';
	import { Label } from '$lib/components/ui/label';
	import * as Select from '$lib/components/ui/select';
	import { Textarea } from '$lib/components/ui/textarea';
	import * as Alert from '$lib/components/ui/alert';
	import { fly } from 'svelte/transition';
	import { onMount } from 'svelte';
	import Seo from '$lib/components/SEO.svelte';
	import image from '$lib/assets/images/error.jpg';
	import { trackPhoneClick } from '$lib/utils/analytics';
	let animate = false;

	onMount(() => {
		setTimeout(() => {
			window.scrollTo(0, 0);
		}, 200);
		animate = true;
	});

	const contactMethods = [
		{ value: 'phone', label: 'Phone' },
		{ value: 'email', label: 'Email' }
	];

	let submitted = $state(false);
	let loading = $state(false);

	let name = $state('');
	let email = $state('');
	let phone = $state('');
	let preferredContact = $state('Either');
	let message = $state('');
	let type = 'General Contact Form';

	const triggerContent = $derived(
		contactMethods.find((f) => f.value === preferredContact)?.label ?? 'Either'
	);

	function resetForm() {
		name = '';
		email = '';
		phone = '';
		preferredContact = '';
		message = '';
	}

	// let url =
	// 	'https://script.google.com/macros/s/AKfycby1A3rEAdqWOuLKL99ODb94HhJ6HoN3eo3cQ02s9JCAwjp3nNvs0ChUTNPQj0cd1QJ6/exec';

	async function handleSubmit(e: Event) {
		e.preventDefault();
		loading = true;
		const formData = {
			name,
			email,
			phone,
			preferredContact,
			message,
			type
		};

		try {
			const response = await fetch('/email/send-email', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(formData)
			});

			if (!response.ok) {
				throw new Error('Failed to send email');
			}

			const result = await response.json();

			if (result.success) {
				resetForm();
				submitted = true;
			} else {
				throw new Error(result.error || 'Failed to send email');
			}
		} catch (error) {
			console.error('Error sending email:', error);
			// Handle error (e.g., show error message to user)
		} finally {
			loading = false;
		}
	}
</script>

<Seo
	title="Contact - Tasmania Local Tour - Tassie Tours"
	description="Get in Touch with Tassie Tours about our range of Fun Tasmania Tour Packages by email or call 0487-163-624."
	keywords="Tasmania Tours, Tasmania local tour, Tassie Tours, Day tours from Hobart, Discover Bruny Island, Cradle Mountain, Active Tasmania tours"
	siteName="Tassie Tours"
	imageURL="/images/hero-carousel-1.jpg"
	logo="/src/lib/assets/logo/logo-black.png"
	author="Tassie Tours"
	type="Contact"
	name="Tassie Tours"
	index={true}
	twitter={true}
	openGraph={true}
	schemaOrg={true}
	socials={[]}
/>

<div class=" -mb-8 w-full lg:grid lg:grid-cols-2">
	<div class="flex items-center justify-center py-12">
		<div class="mx-auto grid gap-6">
			<div class="grid gap-2 text-center">
				<div class="flex w-full items-center justify-center pb-4">
					<enhanced:img
						src="/src/lib/assets/logo/logo-black.png"
						alt="Tassie Tours Logo"
						class="h-24 w-auto"
					/>
				</div>
			</div>
			<form onsubmit={handleSubmit} data-sveltekit-preload-data="off" class=" relative flex w-full flex-col gap-10 px-4 pb-12 pt-6">
				<p class="max-w-lg text-center">
					For a <strong>FREE</strong> Quote or any further enquiries, please contact us, your experts
					in fun Tasmania tours
				</p>
				<div class=" flex flex-wrap items-center justify-center">
					<Button variant="link" href="tel:0409404337" target="_blank" on:click={trackPhoneClick}>0409 404 337</Button> • <Button
						variant="link"
						href="mailto:info@tassietours.com"
						target="_blank">info@tassietours.com</Button
					> •
					<Button variant="link" href="mailto:info@tassietours.com" target="_blank"
						>7am to 7pm</Button
					>
				</div>
				<div class="flex w-full flex-col gap-1.5">
					<Label for="name">Name</Label>
					<Input required type="text" id="name" placeholder="Name" bind:value={name} />
				</div>
				<div class="flex gap-4">
					<div class="flex w-1/2 flex-col gap-1.5">
						<Label for="email">Email</Label>
						<Input
							required
							type="email"
							id="email"
							placeholder="email@domain.com"
							bind:value={email}
						/>
					</div>
					<div class="flex w-1/2 flex-col gap-1.5">
						<Label for="phone">Phone</Label>
						<Input required type="phone" id="phone" placeholder="Phone number" bind:value={phone} />
					</div>
				</div>

				<div class="flex w-full flex-col gap-1.5">
					<Label for="preferredContact">Preferred contact method</Label>
					<Select.Root type="single" bind:value={preferredContact}>
						<Select.Trigger class="">
							{triggerContent}
						</Select.Trigger>
						<Select.Content>
							<Select.Group>
								{#each contactMethods as method}
									<Select.Item value={method.value} label={method.label}>{method.label}</Select.Item
									>
								{/each}
							</Select.Group>
						</Select.Content>
					</Select.Root>
				</div>
				<div class="flex w-full flex-col gap-1.5">
					<Label for="message-2">Message</Label>
					<Textarea
						required
						placeholder="Type your message here."
						id="message-2"
						bind:value={message}
					/>
					<p class="text-sm text-muted-foreground">
						Let us know how we can make your Tasmanian experience even better.
					</p>
				</div>
				<div class="relative mt-6 h-32">
					{#if !submitted}
						<div
							class="absolute inset-0 flex justify-center"
							in:fly={{ x: -50, duration: 300 }}
							out:fly={{ x: -50, duration: 300 }}
						>
							{#if !loading}
								<Button
									type="submit"
									class="z-50 w-32 overflow-hidden rounded-full bg-tt-red p-3 text-center font-semibold text-background transition-all hover:bg-tt-red/80"
								>
									Submit
								</Button>
							{:else}
								<Button
									variant="outline"
									disabled
									class="z-50 flex w-32 overflow-hidden rounded-full bg-tt-red p-3 text-center font-semibold text-background transition-all"
								>
									<Loader2 class="mr-2 h-4 w-4 animate-spin" />
								</Button>
							{/if}
						</div>
					{:else}
						<div
							class="absolute inset-0"
							in:fly={{ x: 50, duration: 300, delay: 300 }}
							out:fly={{ x: -50, duration: 300 }}
						>
							<Alert.Root onclick={() => (submitted = false)} class="text-left hover:bg-accent">
								<CheckCircle class="h-4 w-4" />
								<Alert.Title>Your submission has been received!</Alert.Title>
								<Alert.Description class="text-wrap">
									Keep an eye out. A member of our team will get back to you within 3 business days.
								</Alert.Description>
							</Alert.Root>
						</div>
					{/if}
				</div>
			</form>
		</div>
	</div>
	<div class="hidden bg-muted lg:block">
		<img
			src={image}
			alt="Explore Tasmania Today"
			class="h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
		/>
	</div>
</div>
